import React, { useState, useEffect } from "react";
import PteReadingExplanationButton from "./PteReadingExplanationButton";
import { getPteReadingBlankResultState } from "./pteReadingBlankResultUtils";
import {
  RRBOuterDiv,
  RRBMainDiv,
  RRBParagraph,
  RRBFormControl,
  RRBSelect,
  RRBMenuItem,
} from "./Style";

const resultAnswerStyle = (isCorrect) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: "0.3rem",
  margin: "0 0.2rem",
  padding: "0 0.15rem 0.08rem",
  color: isCorrect ? "#239a48" : "#d93025",
  borderBottom: `2px solid ${isCorrect ? "#239a48" : "#d93025"}`,
  fontWeight: 400,
  verticalAlign: "baseline",
});
 
const ReadingAndWritingBlanks = ({
  textValue,
  dropDownOptions,
  setSelectedAnswers,
  isSubmitted = false,
  correctAnswers = [],
  explanationContext = null,
  testData = null,
  getBlankExplanationTarget = () => null,
}) => {
  const [filledText, setFilledText] = useState(textValue);
  const [selectedValues, setSelectedValues] = useState(
    Array(dropDownOptions?.length)?.fill("")
  );

  const replaceWithDropdown = (textValue, dropDownOptions) => {
    const parts = textValue.split("%{option_name}");
    let result = [];
    for (let i = 0; i < parts.length; i++) {
      result.push(<span key={`text-${i}`}>{parts[i]}</span>);
      if(dropDownOptions){
      if (i < dropDownOptions.length) {
        const options = dropDownOptions[i];
        if (isSubmitted) {
          const { answerText, isCorrect } = getPteReadingBlankResultState({
            selectedAnswer: selectedValues[i],
            correctAnswer: correctAnswers[i],
          });
          const target = getBlankExplanationTarget(i);

          result.push(
            <span key={`result-${i}`} style={resultAnswerStyle(isCorrect)}>
              {answerText}
              {target && (
                <PteReadingExplanationButton
                  explanationContext={explanationContext}
                  testData={testData}
                  target={target}
                />
              )}
            </span>
          );
          continue;
        }

        result.push(
          <RRBFormControl
            key={`dropdown-${i}`}
            sx={{ ml: 1, mr: 1, minWidth: 120, verticalAlign: "middle" }}
          >
            <RRBSelect
              value={selectedValues[i]}
              onChange={(e) => handleDropdownChange(e, i)}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
              renderValue={(selected) => {
                if (!selected) {
                  return <RRBMenuItem>Select Answer</RRBMenuItem>;
                }
                return selected;
              }}
              MenuProps={{
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                getContentAnchorEl: null,
              }}
            >
              {options.map((option, index) => (
                <RRBMenuItem key={index} value={option}>
                  {option}
                </RRBMenuItem>
              ))}
            </RRBSelect>
          </RRBFormControl>
        );
      }}
    }
    return result;
  };

  const handleDropdownChange = (event, index) => {
    const newValues = [...selectedValues];
    newValues[index] = event.target.value;
    setSelectedValues(newValues);
    setSelectedAnswers((prevState) => {
      const updatedAnswers = [...prevState];
      updatedAnswers[index] = event.target.value;
      return updatedAnswers;
    });
  };

  useEffect(() => {
    if(dropDownOptions){
      setSelectedValues(Array(dropDownOptions.length).fill(""));
    }
  }, [dropDownOptions]);

  return (
    <RRBOuterDiv>
      <RRBMainDiv>
        <RRBParagraph variant="body1">
          {replaceWithDropdown(textValue, dropDownOptions)}
        </RRBParagraph>
      </RRBMainDiv>
    </RRBOuterDiv>
  );
};

export default ReadingAndWritingBlanks;
